import * as React from "react";
import { D3Component } from "./D3Component";
import { line } from "sszvis";
export const Line = (props) => (<D3Component datum={props.data} component={line()
    .x(props.x)
    .y(props.y)
    .defined(props.defined)
    .stroke(props.stroke)
    .strokeWidth(props.strokeWidth)
    .key(props.key)
    .valuesAccessor(props.valuesAccessor)
    .transition(props.transition)} renderElement={({ selectionRef }) => (<g ref={selectionRef} {...props.gProps}/>)}/>);



// WEBPACK FOOTER //
// ./src/sszvis-components/Line.tsx